export default {
    title: '{school} Grade {grade} Class {className} <span>({onlineCount}/{totalCount})</span>',
    onlineCount: 'In Session <span>({count})</span>',
    offlineCount: 'Not Joined <span>({count})</span>',
    selectedStudents: '{count} selected',
    giveStar: ({ values }: { values: { isAll: boolean } }) => {
        const { isAll } = values;

        if (isAll) {
            return 'Give stars to <span>all students</span>';
        }

        return '<span>Give Stars</span>';
    },
    giveStarConfirm: 'Give a Praise Star to <strong>{label}</strong>?',
    comment: {
        '0': 'Well done',
        '1': 'Great participation',
        '2': 'Great teamwork',
        '3': 'Great explanation',
        '4': 'Logical answer',
        '5': 'Great expression',
        '6': 'Great presentation',
        '7': 'Creative answer',
        '8': 'Outstanding creativity',
    },
};
